export const moneySign = (value: number): string => {
  return value.toString() + "$";
};
